import { useGSAP } from "@gsap/react";
import * as Sentry from "@sentry/react";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import { gsap } from "gsap/dist/gsap";
import React from "react";
import ReactDOM from "react-dom/client";

import { Provider, getServerData, getTemplate } from "@reactivated";

import { activateTranslations } from "@thelabnyc/thelabui/src/utils/i18n";

const { props, context } = getServerData();

if (context.SENTRY_DSN) {
    Sentry.init({
        dsn: context.SENTRY_DSN,
        release: context.CI_COMMIT_SHA,
        environment: context.CI_COMMIT_REF_SLUG,
        integrations: [],
        // Filter out third-party errors that are not actionable
        ignoreErrors: [
            // https://thelab.sentry.io/issues/GOODCOOK-CMS-49
            /reCAPTCHA Timeout/,
            // https://thelab.sentry.io/issues/GOODCOOK-CMS-2E
            // Third-party "Launcher Failed" errors from webkit-masked cross-origin
            // scripts on Mobile Safari/iOS. No first-party frames in stacktrace.
            /Launcher Failed/,
            // https://thelab.sentry.io/issues/GOODCOOK-CMS-4F
            // iOS in-app browser (e.g. Instagram) tries to access
            // window.webkit.messageHandlers which may not be set up. No first-party frames.
            /webkit\.messageHandlers/,
        ],
        denyUrls: [
            /recaptcha\/releases/,
            // https://thelab.sentry.io/issues/GOODCOOK-CMS-76
            // Errors thrown by Electron's internal sandbox/IPC bundle when the
            // site is loaded inside an Electron-based app (e.g. its built-in
            // scroll position restoration). No first-party frames.
            /^node:electron\//,
        ],
    });
}

activateTranslations(context.i18n);

const main = async () => {
    const Template = await getTemplate(context);
    gsap.registerPlugin(useGSAP, ScrollTrigger);

    ReactDOM.hydrateRoot(
        document,
        <React.StrictMode>
            <Provider value={context}>
                <Template {...props} />
            </Provider>
        </React.StrictMode>,
    );
};

await main();
